import { MnosFilters } from '../models/mnos';

export const mnosQueries = {
  all: ['mnos'] as const,
  list: (filters: MnosFilters) => [...mnosQueries.all, filters],
  infinityList: (filters: MnosFilters) => [...mnosQueries.all, filters],
  detail: (id: string) => [...mnosQueries.all, 'detail', id],
};
